import { useSelector } from 'react-redux';
import { getAllServicesCategoriesList } from 'store/selectors/servicesCategories';
import RequestCategoriesWrapper from 'pages/Services/components/RequestCategoriesWrapper';
import CategoriesList from 'pages/Services/components/CategoriesList';
import { Row } from 'components-antd';
import { getUserRoleSelector } from 'store/selectors/user';
import { AGENT, TEAM_BASIC } from 'settings/constants/roles';
import styles from './styles.module.scss';
import { useKitsQuoteRedirect } from 'pages/Services/hooks/use-kits-quote-redirect';
import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';
import {
  conciergeAgentDefaultItems,
  conciergeBasicAgentDefaultItems,
} from 'pages/Services/constants';

interface ConciergeCategoriesListProps {
  setIsSearch: (arg0: boolean) => void;
}

export const ConciergeCategoriesList = ({ setIsSearch }: ConciergeCategoriesListProps) => {
  const list = useSelector(getAllServicesCategoriesList);
  const userRole = useSelector(getUserRoleSelector);
  const agentRole = useSelector(getAgentTeamRoleSelector);

  useKitsQuoteRedirect();

  const handleCategoryClick = () => {
    setIsSearch(true);

    return;
  };

  const sortedList = list.sort((a: { Title: string }, b: { Title: string }) =>
    a.Title.localeCompare(b.Title),
  );

  return (
    <RequestCategoriesWrapper className={styles.wrapper}>
      {userRole === AGENT ? (
        <CategoriesList
          items={
            agentRole === TEAM_BASIC ? conciergeBasicAgentDefaultItems : conciergeAgentDefaultItems
          }
          onClick={handleCategoryClick}
        />
      ) : null}
      <Row justify="start" className={styles.dividerWrapper}>
        Browse
      </Row>
      <CategoriesList items={sortedList} onClick={handleCategoryClick} />
    </RequestCategoriesWrapper>
  );
};
